
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { FileReferenceModel } from './Entities.GormCrm.FileReference';
import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class TaskAttachmentModel extends Model<TaskAttachmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'taskActionId', type: 'string' },
		{ name: 'uploaded', type: 'Date' },
		{ name: 'companyId', type: 'string' },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'fileReferenceId', type: 'string' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'fileReference', type: 'FileReferenceModel', isHidden: true, isObject: true, new: () => { return new FileReferenceModel }, properties: () => { return FileReferenceModel.classProperties } },
		{ name: 'taskAction', type: 'TaskActionModel', isHidden: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public taskActionId?: string;
	public uploaded?: Date;
	public companyId?: string;
	public taskflowId?: string;
	public fileReferenceId?: string;
	public deleted?: Date;
	public company?: CompanyModel;
	public fileReference?: FileReferenceModel;
	public taskAction?: TaskActionModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.taskActionId = undefined;
		this.uploaded = undefined;
		this.companyId = undefined;
		this.taskflowId = undefined;
		this.fileReferenceId = undefined;
		this.deleted = undefined;
		this.company = undefined;
		this.fileReference = undefined;
		this.taskAction = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return TaskAttachmentModel.classProperties;
	}
}

